import CaptchaLoader from "./CaptchaLoader";
import CaptchaComponent from "./components/CaptchaComponent.vue";

const CaptchaComponentSimple = {
    install(Vue, options) {
        if (!options) {
            options = {};
        }

        const captchaLoader = new CaptchaLoader(options.siteKey);

        if (options.init === true) {
            captchaLoader.init();
        }

        Vue.captchaInit = Vue.prototype.$captchaInit = async () => {
            return await captchaLoader.init();
        };

        Vue.captcha = Vue.prototype.$captcha = async (action) => {
            return await captchaLoader.getToken(action);
        };

        Vue.component('vue-captcha', CaptchaComponent);
    }
};

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(CaptchaComponentSimple);
}

export default CaptchaComponentSimple;